import { render, staticRenderFns } from "./infoDiploma.vue?vue&type=template&id=6e6afc94&scoped=true"
import script from "./infoDiploma.vue?vue&type=script&lang=js"
export * from "./infoDiploma.vue?vue&type=script&lang=js"
import style0 from "./infoDiploma.vue?vue&type=style&index=0&id=6e6afc94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6afc94",
  null
  
)

export default component.exports